import {
    Module,
    VuexModule,
    Mutation,
    getModule,
} from 'vuex-module-decorators';
import store from '~common-store';
import { LoadingState } from '~common-interfaces/loading.interface';

@Module({ dynamic: true, store, name: 'loading', namespaced: true })
class Loading extends VuexModule implements LoadingState {
    loading = false;

    @Mutation
    showLoading(flag: boolean) {
        this.loading = flag;
    }
}

export const LoadingModule = getModule(Loading);
